export default {
  "nl": {
    "upsell": {
      "contact_us": "Geïnteresseerd? Neem contact op!",
      "decisions_partners": {
        "guidance": "Beslissingspartners kunnen voorstellen maken en/of beheren als ze daarvoor toestemming hebben gekregen.<br>Je kan meer lezen over beslissingspartners <a class='is-underlined' href='/help/content/partners/ partners.html#decision-partners' target='_blank'>hier</a>",
        "intercom": "Hallo Ziggu! Ik ben geïnteresseerd in de functie Beslissingspartners. Kan je wat meer informatie geven? Met vriendelijke groet, %{name}"
      },
      "decisions_reminders": {
        "guidance": "Met herinneringen kunt u klanten automatisch laten weten dat er voorstellen wachten op een beslissing.<br>Je kan meer lezen over herinneringen <a class='is-underlined' href='/help/content/decisions/decisions.html?#step-3-optional-settings' target='_blank'>hier</a>",
        "intercom": "Hallo Ziggu! Ik ben geïnteresseerd in de functie Herinneringen. Kan je wat meer informatie geven? Met vriendelijke groet, %{name}"
      },
      "integration_aircall": {
        "intercom": "Hallo Ziggu! Ik ben geïnteresseerd in de integratie met Aircall. Kunt u wat meer informatie geven? Met vriendelijke groeten, %{name}",
        "marketplace": {
          "title": "Aircall",
          "title_sub": "Push contacten naar Aircall of log gesprekken in Ziggu"
        }
      },
      "integration_archisnapper": {
        "intercom": "Hallo Ziggu! Ik ben geïnteresseerd in de integratie met Archisnapper. Kunt u wat meer informatie geven? Met vriendelijke groeten, %{name}",
        "marketplace": {
          "title": "Archisnapper",
          "title_sub": "Push uw Archisnapper-checklists naar Ziggu"
        }
      },
      "integration_astena": {
        "intercom": "Hallo Ziggu! Ik ben geïnteresseerd in de integratie met Astena. Kunt u wat meer informatie geven? Met vriendelijke groeten, %{name}",
        "marketplace": {
          "title": "Astena",
          "title_sub": "Push uw betaalschijven, facturen en andere financiële gegevens Ziggu"
        }
      },
      "integration_bouwsoft": {
        "intercom": "Hallo Ziggu! Ik ben geïnteresseerd in de integratie met Bouwsoft. Kun je wat meer informatie geven? Vriendelijke groeten, %{name}",
        "marketplace": {
          "title": "Bouwsoft",
          "title_sub": "Push jouw Bouwsoft-contacten, units, en betaalschijven naar Ziggu"
        }
      },
      "integration_bricsys": {
        "intercom": "Hallo Ziggu! Ik ben geïnteresseerd in de integratie met Bricsys. Kunt u wat meer informatie geven? Met vriendelijke groeten, %{name}",
        "marketplace": {
          "title": "Bricsys",
          "title_sub": "Push uw Bricsys-documenten naar Ziggu"
        }
      },
      "integration_exact_online": {
        "intercom": "Hallo Ziggu! Ik ben geïnteresseerd in de integratie met Exact Online. Kunt u wat meer informatie geven? Met vriendelijke groeten, %{name}",
        "marketplace": {
          "title": "Exact Online",
          "title_sub": "Push uw Exact Online betaalschijven, facturen en andere financiële gegevens naar Ziggu"
        }
      },
      "integration_hubspot": {
        "intercom": "Hallo Ziggu! Ik ben geïnteresseerd in de integratie met Hubspot. Kun je wat meer informatie geven? Vriendelijke groeten, %{name}",
        "marketplace": {
          "title": "Hubspot",
          "title_sub": "Push jouw Hubspot-contacten, units, en documenten naar Ziggu"
        }
      },
      "integration_kpd": {
        "intercom": "Hallo Ziggu! Ik ben geïnteresseerd in de integratie met KPD. Kunt u wat meer informatie geven? Met vriendelijke groeten, %{name}",
        "marketplace": {
          "title": "KPD",
          "title_sub": "Push je betaalschijven, facturen en andere financiële gegevens naar Ziggu"
        }
      },
      "integration_letsbuild": {
        "intercom": "Hallo Ziggu! Ik ben geïnteresseerd in de integratie met Letsbuild. Kun je wat meer informatie geven? Vriendelijke groeten, %{name}",
        "marketplace": {
          "title": "Letsbuild",
          "title_sub": "Push jouw Letsbuild-punten naar Ziggu"
        }
      },
      "integration_navision": {
        "intercom": "Hallo Ziggu! Ik ben geïnteresseerd in de integratie met Microsoft Dynamics Navision. Kunt u wat meer informatie geven? Met vriendelijke groeten, %{name}",
        "marketplace": {
          "title": "Microsoft Dynamics Navision",
          "title_sub": "Push je contacten, betaalschijven, facturen en andere financiële gegevens naar Ziggu"
        }
      },
      "integration_power_bi": {
        "intercom": "Hallo Ziggu! Ik ben geïnteresseerd in de integratie met PowerBI. Kunt u wat meer informatie geven? Met vriendelijke groeten, %{name}",
        "marketplace": {
          "title": "PowerBI",
          "title_sub": "Push uw PowerBI-statistieken en andere gegevens naar Ziggu"
        }
      },
      "integration_realpad": {
        "intercom": "Hallo Ziggu! Ik ben geïnteresseerd in de integratie met Realpad. Kunt u wat meer informatie geven? Met vriendelijke groeten, %{name}",
        "marketplace": {
          "title": "Realpad",
          "title_sub": "Push je contacten naar Ziggu"
        }
      },
      "integration_salesforce": {
        "intercom": "Hallo Ziggu! Ik ben geïnteresseerd in de integratie met Salesforce. Kan je wat meer informatie geven? Met vriendelijke groet, %{name}",
        "marketplace": {
          "title": "Salesforce",
          "title_sub": "Push jouw Salesforce-contacten, units, documenten en betaalschijven naar Ziggu"
        }
      },
      "integration_sap": {
        "intercom": "Hallo Ziggu! Ik ben geïnteresseerd in de integratie met SAP. Kunt u wat meer informatie geven? Met vriendelijke groeten, %{name}",
        "marketplace": {
          "title": "SAP",
          "title_sub": "Push je contacten, betaalschijven, facturen en andere financiële gegevens naar Ziggu"
        }
      },
      "integration_sharepoint": {
        "intercom": "Hallo Ziggu! Ik ben geïnteresseerd in de integratie met Sharepoint. Kunt u wat meer informatie geven? Met vriendelijke groeten, %{name}",
        "marketplace": {
          "title": "Sharepoint",
          "title_sub": "Push je documenten naar Ziggu"
        }
      },
      "integration_teamleader": {
        "intercom": "Hallo Ziggu! Ik ben geïnteresseerd in de integratie met Teamleader. Kunt u wat meer informatie geven? Met vriendelijke groeten, %{name}",
        "marketplace": {
          "title": "Teamleader",
          "title_sub": "Push je contacten, betaalschijven, facturen en andere financiële gegevens naar Ziggu"
        }
      },
      "integration_yuki": {
        "intercom": "Hallo Ziggu! Ik ben geïnteresseerd in de integratie met Yuki. Kunt u wat meer informatie geven? Met vriendelijke groeten, %{name}",
        "marketplace": {
          "title": "Yuki",
          "title_sub": "Push je betaalschijven, facturen en andere financiële gegevens naar Ziggu"
        }
      },
      "integration_zoho": {
        "intercom": "Hallo Ziggu! Ik ben geïnteresseerd in de integratie met Zoho. Kun je wat meer informatie geven? Vriendelijke groeten, %{name}",
        "marketplace": {
          "title": "Zoho",
          "title_sub": "Push jouw Zoho-contacten, units, documenten en betaalschijven naar Ziggu"
        }
      },
      "marketplace": {
        "category": {
          "feature": "Feature",
          "integration": "Integratie"
        }
      },
      "not_included": "💡 Geïnteresseerd in deze functionaliteit? 💡",
      "project_email_forwarding": {
        "cta": "E-mails doorsturen naar {project_name}",
        "description": "Laat iedereen binnen je team e-mails rechtstreeks doorsturen naar je Ziggu-projecten.",
        "intercom": "Hallo Ziggu! Ik wil graag e-mails doorsturen naar projecten. Kan je wat meer informatie geven? Met vriendelijke groet, %{name}",
        "marketplace": {
          "title": "Project email forwarding",
          "title_sub": "E-mails rechtstreeks doorsturen naar je Ziggu-projecten."
        },
        "title": "Nieuw! E-mails doorsturen naar projecten",
        "youtube_id": "vLQtH9GzAXc"
      },
      "project_experience": {
        "contactme": "Je mag mij contacteren hierover!",
        "cta": "Op zoek naar een betere projectervaring?",
        "description": "Gepersonaliseerde project-URL en inlogscherm <br/> Eigen projectomgeving wanneer ingelogd <br/> Project branded e-mails <br/> Maakt projectsamenwerking met andere vastgoedontwikkelaars eenvoudiger",
        "intercom": "Hallo Ziggu! Ik ben geïnteresseerd in de Project Experience-module. Kan je wat meer informatie geven? Met vriendelijke groet, %{name}",
        "marketplace": {
          "title": "Project experience",
          "title_sub": "Verbeter uw projectbranding met een gepersonaliseerde project-URL en -omgeving"
        },
        "title": "Laat jouw klanten zich thuis voelen met de gloednieuwe Project Experience!",
        "youtube_id": "f26cNo2rwWE"
      },
      "proposal_choice_lists": {
        "guidance": "Met keuzelijsten kunt u klanten keuzes laten maken in voorstellen.<br>Je kan meer lezen over keuzelijsten <a class='is-underlined' href='/help/content/decisions/decisions.html#choice-list' target='_blank'>hier</a>",
        "intercom": "Hallo Ziggu! Ik ben geïnteresseerd in de functie Keuzelijsten. Kan je wat meer informatie geven? Met vriendelijke groet, %{name}"
      },
      "signatures": {
        "cta_text": "Handtekeningen nodig voor uw documenten? Neem contact op",
        "guidance": "Met handtekeningen kunt u klanten belangrijke documenten digitaal laten ondertekenen.<br>Je kan meer lezen over herinneringen <a class='is-underlined' href='/help/content/decisions/decisions.html#electronic-signature' target='_blank'>hier</a>",
        "intercom": "Hallo Ziggu! Ik ben geïnteresseerd in de functie Handtekeningen. Kan je wat meer informatie geven? Met vriendelijke groet, %{name}"
      }
    }
  }
}